import {isArray} from '../../../../../../common/types/guards/isArray';
import {isFunction} from '../../../../../../common/types/guards/isFunction';
import {DefaultTableProps} from '../DefaultTable';

export function isCheckboxMode(o?: any): o is Required<Pick<DefaultTableProps<any>, 'checkedRows' | 'setCheckedRows'>> {
    return isArray(o?.checkedRows)
        && isFunction(o?.setCheckedRows);
}
